import React from "react";
import { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import Image from "next/image";
import Link from "next/link";
import AOS from "aos";

import Pro01 from "@/public/static/images/project_01.jpg";
import Pro02 from "@/public/static/images/project_02.jpg";
import Pro03 from "@/public/static/images/project_03.jpg";
import Pro04 from "@/public/static/images/project_04.jpg";

function itpsuiteapp() {
  AOS.init({
    offset: 200,
    duration: 600,
    easing: "ease-in-out-sine",
    delay: 200,
    mirror: true,
  });

  return (
    <div className="wrapper">
      <Header />
      <section className="proj">
        <div className="container">
          <div className="row">
            <div className="col-12 project_box">
              <div className="row">
                <div className="col-12 col-md-7 order-md-1 order-2">
                  <div>
                    <div className="project-heading">
                      <h1 className="t-pink">ITP SUITE APPLICATION</h1>
                    </div>
                  </div>
                  {/* <div className="badge_box">
                    <Link href="/ourservice/web_application">
                      <span className="badge rounded-pill text-bg-light">
                        Web & App Development
                      </span>
                    </Link>
                    <Link href="/ourservice/web_application">
                      <span className="badge rounded-pill text-bg-light">
                        Application UX/UI Design
                      </span>
                    </Link>
                    <Link href="/ourservice/web_application">
                      <span className="badge rounded-pill text-bg-light">
                        iOS & Android Application Development
                      </span>
                    </Link>
                  </div> */}
                  <div className="project-list">
                    <ul>
                      <li>Digitalization & Paperless Operation for Internal</li>
                      <li>Task Reduction to Enhance Productivity</li>
                      <li>
                        Convenience and Inclusive: Anywhere, Anytime for
                        Everyone{" "}
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-12 col-md-5 order-md-2 order-1">
                  <Image
                    loading="lazy"
                    src={Pro01}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                </div>
              </div>
            </div>

            <div className="col-12 project_content">
              <div className="row mb-5">
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <Image
                    loading="lazy"
                    src={Pro02}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto "
                  />
                </div>
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <h2 className="t-pink mb-2">Function</h2>
                  <p>
                    - Clock in – Clock out
                    <br />
                    - Overtime request
                    <br />
                    - Flextime request
                    <br />
                    - Leave request
                    <br />
                    - On duty request
                    <br />
                    - Attendance record
                    <br />
                    - Manager online approval
                    <br />
                    - Meeting room reservation
                    <br />
                    - Car reservation
                    <br />- HR database
                  </p>
                </div>
              </div>

              <div className="row mb-5">
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <Image
                    loading="lazy"
                    src={Pro03}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto mb-3"
                  />
                  <Image
                    loading="lazy"
                    src={Pro04}
                    alt="ITP SUITE APPLICATION"
                    className="img-fluid mx-auto mb-3"
                  />
                </div>
                <div className="col-12 col-md-6 mb-3 project_content-inner">
                  <h2 className="t-pink mb-2">Background</h2>
                  <p>
                    1. Many paper of application forms
                    <br />
                    2. Time consuming for manager to approve by signing paper
                    <br />
                    3. Database was not integrated
                  </p>
                  <div className="h-25"></div>
                  <h2 className="t-pink mb-2">Result</h2>
                  <p>
                    1. Database is digitized and integrated
                    <br />
                    2. Reduce time consumption
                    <br />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default itpsuiteapp;
